
import React, {useState} from 'react'
import $ from "jquery";
const EnquiryModal = () => {
    const [values, SetValues] = useState({
        name: '',
        mobile: '',
        email: '',
        message: '',
        error: false,
        success: ''
    })
    const {name, email, mobile, message} = values;
    const handleChange = (name) => (e) => {
        SetValues({...values, [name]: e.target.value});
        console.log(values)
    }
    const onSubmit = (e) => {
        e.preventDefault();
        let form = $(e.target)[0];
        fetch('/projects/english-tutor/api_public/students/login', {
            mode: 'no-cors',
            method: 'POST',
            body: new FormData(form)
        }).then(response => response.json()).then(responseJson => console.log(responseJson)).catch((err) => {
            console.log('Error', err)
        });
        SetValues({
            ...values, name: '',
            mobile: '',
            email: '',
            message: '',
            error: false,
            success: ''
        })
    }
    return (
        <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Enquiry</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form id="" onSubmit={onSubmit} method='post'>
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="name">Name*</label>
                                        <input type="text" className="form-control " name="name" id="name" required=""
                                               data-error="Please enter your name" value={name}
                                               onChange={handleChange('name')}/>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <input type="email" className="form-control" name="email" id="email"
                                               required="" data-error="Please enter your email" value={email}
                                               onChange={handleChange('email')}/>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="number">Mobile*</label>
                                        <input type="text" className="form-control" name="mobile" id="number"
                                               required="" data-error="Please enter your number" value={mobile}
                                               onChange={handleChange('mobile')}/>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="hours">Hours*</label>
                                        <select className='form-control' name='hours' id='shift'>
                                            <option value="4 Hours">4 Hours</option>
                                            <option value="6 Hours">6 Hours</option>
                                            <option value="8 Hours">8 Hours</option>
                                            <option value="12 Hours">12 Hours</option>
                                        </select>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="message">Message*</label>
                                        <textarea name="message" className="form-control" id="message" required=""
                                                  data-error="Write your message" value={message}
                                                  onChange={handleChange('message')}></textarea>
                                        <div className="help-block with-errors"></div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" form='' className="btn btn-primary mb-4">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EnquiryModal